import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import CasesChartV2 from './components/v2/CasesChartV2';
import CasesChartRecoveryV2 from './components/v2/CasesChartRecoveryV2';
import DeathChartRecoveryV2 from './components/v2/DeathChartRecoveryV2';
import TestingChartV2 from './components/v2/TestingChartV2';
import HospitalChartV2 from './components/v2/HospitalChartV2';
import TestingPopChartV2 from './components/v2/TestingPopChartV2';
import VaccineChartV2 from './components/v2/VaccineChartV2';
import VaccineCumulativeChartV2 from './components/v2/VaccineCumulativeChartV2';
import RegistrationActiveInactiveChartV2Show from './components/v2/RegistrationActiveInactiveChartV2Show';
import RegistrationRaceTotalChartV2Show from './components/v2/RegistrationRaceTotalChartV2Show';
import RegistrationStageTotalChartV2Show from './components/v2/RegistrationStageTotalChartV2Show';
import RegistrationTotalCardV2Show from './components/v2/RegistrationTotalCardV2Show';
import RegistrationTotalTableV2Show from './components/v2/RegistrationTotalTableV2Show';
import RegistrationRaceTotalTableShowV2 from './components/v2/RegistrationRaceTotalTableShowV2';
import RegistrationActiveCardV2Show from './components/v2/RegistrationActiveCardV2Show';
import RegistrationDashV2 from './components/v2/RegistrationDashV2';
import RegistrationWeeklyChartV2Show from './components/v2/RegistrationWeeklyChartV2Show';
import RegistrationWeeklyTableV2Show from './components/v2/RegistrationWeeklyTableV2Show';
import RegistrationProviderChartV2Show from './components/v2/RegistrationProviderChartV2Show';
import RegistrationProviderTableV2Show from './components/v2/RegistrationProviderTableV2Show';
import RegistrationRaceTotalChartStackedV2Show from './components/v2/RegistrationRaceTotalChartStackedV2Show';
import RegistrationWeeklyChartNormalV2Show from './components/v2/RegistrationWeeklyChartNormalV2Show';
import RegistrationWeeklyChartAreaV2Show from './components/v2/RegistrationWeeklyChartAreaV2Show';
import RegistrationProviderChartStackedV2Show from './components/v2/RegistrationProviderChartStackedV2Show';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import './resources/css/page.css';

// add error page while im doing this stuff
const App = () => {
  return (
    <HashRouter>
      <Container fluid>
          <Switch>
            <Route exact path="/" component={CasesChartV2}/>
            <Route exact path="/charts/current/cases" component={CasesChartV2}/>
            <Route exact path="/charts/current/vaccine" component={VaccineChartV2}/>
            <Route exact path="/charts/current/vaccineCumulative" component={VaccineCumulativeChartV2}/>
            <Route exact path="/charts/current/testing" component={TestingChartV2}/>
            <Route exact path="/charts/recovery/hospital" component={HospitalChartV2}/>
            <Route exact path="/charts/recovery/testing" component={TestingChartV2}/>
            <Route exact path="/charts/recovery/cases" component={CasesChartRecoveryV2}/>
            <Route exact path="/charts/recovery/deaths" component={DeathChartRecoveryV2}/>
            <Route exact path="/charts/recovery/testingPop" component={TestingPopChartV2}/>
            <Route exact path="/charts/registration/race" component={RegistrationRaceTotalChartV2Show}/>
            <Route exact path="/charts/registration/stage" component={RegistrationStageTotalChartV2Show}/>
            <Route exact path="/charts/registration/active" component={RegistrationActiveInactiveChartV2Show}/>
            <Route exact path="/charts/registration/weekly" component={RegistrationWeeklyChartV2Show}/>
            <Route exact path="/charts/registration/weeklyNormal" component={RegistrationWeeklyChartNormalV2Show}/>
            <Route exact path="/charts/registration/weeklyArea" component={RegistrationWeeklyChartAreaV2Show}/>
            <Route exact path="/charts/registration/provider" component={RegistrationProviderChartV2Show}/>
            <Route exact path="/charts/registration/providerStacked" component={RegistrationProviderChartStackedV2Show}/>
            <Route exact path="/charts/registration/raceStacked" component={RegistrationRaceTotalChartStackedV2Show}/>
            <Route exact path="/cards/registration/total" component={RegistrationTotalCardV2Show}/>
            <Route exact path="/cards/registration/active" component={RegistrationActiveCardV2Show}/>
            <Route exact path="/tables/registration/total" component={RegistrationTotalTableV2Show}/>
            <Route exact path="/tables/registration/race" component={RegistrationRaceTotalTableShowV2}/>
            <Route exact path="/tables/registration/weekly" component={RegistrationWeeklyTableV2Show}/>
            <Route exact path="/tables/registration/provider" component={RegistrationProviderTableV2Show}/>
            <Route exact path="/demo/registration" component={RegistrationDashV2}/>
            <Route component={Error}/>
         </Switch>
      </Container> 
    </HashRouter>
  );
}

export default App;

